import React from "react";
import "./style.css";
import {Link} from "react-router-dom";
import {PATH} from "../../constants";
import notificationStore from "../../store/notificationStore";
import {NotificationItemDialog} from "./NotificationItem";
import {isEmpty} from "lodash";
import {readMarkNotiById} from "../../network/notiApi";
import {ERROR_CODE} from "../../constants/error";
import {text} from "../../constants/text";

const DialogNotification = ({isActived, merchantProfile}) => {
    const {notifications} = notificationStore();

    return (
        <div
            className={`dropdown-menu absolute top-16 right-0 -mr-8 px-2.5 py-3.5 w-[500px] bg-white rounded-2xl shadow-custom font-inter text-black transition-all ${
                isActived ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
        >
            <div className="flex py-4 items-center gap-3.5">
                <span className="text-sm font-bold">Thông báo mới nhất</span>
            </div>
            <div>
                {!isEmpty(notifications?.items) ? notifications?.items?.slice(0, 4)?.map((notification) => (
                        <NotificationItemDialog
                            key={notification.id}
                            notification={notification}
                            onClick={() => readMarkNotiById(notification?.id)}
                        />
                    )) :
                    <div className="flex justify-center items-center py-4">
                        <div className="text-sm">{text.emptyNotification}</div>
                    </div>
                }
            </div>
            <div className="flex py-4 justify-center items-center">
                <Link to={merchantProfile?.code !== ERROR_CODE["MERCHT-05"] ? PATH.NOTIFICATION : '#'}>
                    <div className="text-sm">Xem tất cả</div>
                </Link>
            </div>
        </div>
    );
};

export default DialogNotification;
